import { createContext } from 'react';
import { TAccountRightsFeatureList } from '@app/services/account-rights-service/response-interfaces/account-rights';

export interface RoleBasedRouteContext {
  feature: TAccountRightsFeatureList | null;
}

export const roleBasedRouteContext = createContext({} as RoleBasedRouteContext);
